import React from "react";
import Header from "../components/Header";
import Hero from "../components/About/Hero";
import FundraisingProgress from "../components/About/FundraisingProgress";
import ImpactStories from "../components/About/HowWeDoIt";
import ImpactSection from "../components/About/ImpactSection";
import Quote from "../components/About/Quote";
import FAQ from "../components/About/FAQs";
import UpdatesMedia from "../components/About/UpdateMedia";

const Aboutpage = () => {
  return (
    <>
      <Hero />
      {/* <FundraisingProgress /> */}
      <Quote />
      <ImpactStories />
      <ImpactSection />
      {/* <Quote /> */}
      {/* <FAQ /> */}
      <UpdatesMedia />
    </>
  );
};

export default Aboutpage;
